<template>
  <div class="current-license">

    <template v-if="user.subsPlan">
      <div class="title">
        {{ $ml.get('Current license') }}
        <div v-if="$store.getters['user/isSubsCanceled']" class="status-badge canceled">
          {{ $ml.get('Canceled') }}
        </div>
      </div>
      <div class="plan">
        <div class="value">
          {{ user.subsPlan == 'Premium_IPNUK' ? 'Premium' : user.subsPlan == 'Exact_IPNUK' ? 'Exact' : user.subsPlan }}
        </div>
        <div class="period">
          {{ $ml.get('period') }}
        </div>
      </div>

      <div class="btns">
        <router-link v-if="showUpgradeBtn" class="upgrade" to="/dashboard/plans">
          {{ $ml.get('Upgrade') }}
        </router-link>
        <router-link v-else to="/dashboard/plans" class="reactivate">
          {{ $ml.get('Reactivate') }}
        </router-link>
        <!-- <button 
          v-if="user.subsPlan !== 'impact'"
          @click="pause_modal_opened = true" 
          class="pause h-empty-btn"
        >
          {{ $ml.get('Pause') }}
        </button> -->
        <button 
          v-if="showCancelBtn"
          @click="cancel_modal_opened = true" 
          class="unsub h-empty-btn"
        >
          {{ $ml.get('Cancel') }}
        </button>
      </div>
    </template>

    <template v-else>
      <div class="no-lic">
        {{ $ml.get('No License') }}
      </div>
      <app-btn to="/dashboard/plans">
        {{ $ml.get(`Subscribe`) }}
      </app-btn>
    </template>

    <transition name="modal-fade-scale">
      <Feedback
        @close="cancel_modal_opened = false"
        @open-pause="pause_modal_opened = true"
        v-if="cancel_modal_opened"
      />
    </transition>

    <!-- <transition name="modal-fade-scale">
      <PauseModal
        @close="pause_modal_opened = false"
        v-if="pause_modal_opened"
      />
    </transition> -->

  </div>
</template>

<script>
import { PlansAPI } from '@/api';
import { mapGetters } from 'vuex'
import Feedback from './feedback/Feedback';
import PauseModal from './PauseModal';
export default {
  data() {
    return {
      cancel_modal_opened: false,
      pause_modal_opened: false,
    }
  },
  methods: {
    showIAPModal() {
      this.$store.commit('modals/alert/open', {
        text: this.$ml.get('We are sorry, but you can only cancel your subscription in our Apple app'),
      });
    },
  },
  components: {
    Feedback,
    PauseModal,
  },
  computed: {

    ...mapGetters({
      user: 'user/data',
    }),

    period() {
      if(this.user.subsPlan === 'impact') {
        return this.$ml.get('one time')
      } else {
        if(this.user.subsPeriod == 'month') {
          return this.$ml.get('monthly')
        } else {
          return this.$ml.get('annual')
        }
      }
    },

    isIAP() {
      return this.user.plan.from === 'iap';
    },

    showCancelBtn() {
      return this.user.subsPlan !== 'impact' 
        && this.$store.getters['user/isSubsActive'] 
        && !this.$store.getters['user/isSubsCanceled'];
    },

    showUpgradeBtn() {
      const getters = this.$store.getters;
      return this.user.subsPlan === 'impact'
       || (getters['user/isSubsActive'] && !getters['user/isSubsCanceled']);
    },
  }
}
</script>

<style lang="scss" scoped>

.current-license {

  padding: 10px;
  border-radius: 5px;
  background: #f7f7f7;
  flex-grow: 1;
  margin-right: 20px;
  border-bottom: 5px solid #eee;
  max-width: 250px;
  line-height: 1.5;
  &:last-child {
    margin-right: 0;
  }

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .title {
    margin-bottom: 10px;

    display: flex;
    flex-direction: row;
    align-items: center;

    .status-badge {

      margin-left: 10px;

      &.canceled {
        border: 1px solid red;
        border-radius: 3px;
        padding: 1px 5px;
        display: inline-flex;
        font-size: 10px;
        font-weight: 500;
        text-transform: uppercase;
        color: red;
      }
    }
  }
  .plan {
    margin-bottom: 10px;
    flex-grow: 1;

    display: flex;
    flex-direction: column;
    line-height: 1.2;

    .value {
      text-transform: capitalize;
      font-size: 26px;
      font-weight: bold;
    }

    .period {
      font-size: 14px;
    }
  }

  .btns {
    .upgrade {
      font-size: 12px;
      margin-right: 10px;
    }
    .unsub {
      font-size: 12px;
      color: #E54D42;
    }
    .pause {
      margin-right: 10px;
      font-size: 12px;
      color: #F2994A;
    }
    .reactivate {
      font-size: 12px;
      margin-right: 10px;
    }
  }

  .no-lic {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 500;
  }
}

</style>
